module.exports = __webpack_public_path__ + "static/img/订阅号275x275.0b575c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/订阅号275x275.png
// module id = 250
// module chunks = 99